interface StatsCardProps {
  label: string;
  value: string | number;
  change?: string;
  trend?: 'up' | 'down' | 'neutral';
}

export function StatsCard({ label, value, change, trend }: StatsCardProps) {
  return (
    <div className="bg-surface rounded-lg border border-border shadow-sm p-4 sm:p-6">
      <p className="text-sm text-content-subtle">{label}</p>
      <p className="text-2xl font-semibold text-content font-mono mt-1">
        {value}
      </p>
      {change && trend && (
        <div className="flex items-center mt-2">
          {trend === 'up' && (
            <svg
              className="w-4 h-4 text-success mr-1"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 10l7-7m0 0l7 7m-7-7v18"
              />
            </svg>
          )}
          {trend === 'down' && (
            <svg
              className="w-4 h-4 text-danger mr-1"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 14l-7 7m0 0l-7-7m7 7V3"
              />
            </svg>
          )}
          {trend === 'neutral' && (
            <svg
              className="w-4 h-4 text-content-subtle mr-1"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 12h14"
              />
            </svg>
          )}
          <span
            className={`text-sm font-medium ${
              trend === 'up'
                ? 'text-success'
                : trend === 'down'
                ? 'text-danger'
                : 'text-content-subtle'
            }`}
          >
            {change}
          </span>
        </div>
      )}
    </div>
  );
}
